<template>
  <div class="solution-security">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionAuditing"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : (index == indexActive)}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor(('#anchor-' + index ), index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="solution-content-intro">
        <div class="content">
          优图内容安全解决方案是针对广告、社交、游戏、直播、短视频等行业存在的UGC图片内容安全问题推出的解决方案，该方案基于优图图像识别技术，可以精准识别出图片中的不适宜内容，为客户提供一站式图像内容安全服务，提高人工效率，助力客户更好地进行风险管控。
        </div>
      </div>
      <div class="core-competence">
        <div class="core-competence-item"
          :class="{'core-even': (index % 2 == 0), 'last-core' : (index == (introAuditing.length - 1))}"
          :style="{backgroundImage:'url(' + item.imgUrl + ')',backgroundSize:'570px 310px' }"
          v-for="(item, index) in introAuditing"
          :key="index">
          <div class="core-img" ></div>
          <div class="core-title">
            {{item.title}}
          </div>
          <div class="core-content">
            {{item.content}}
          </div>
        </div>
      </div>
    </div>
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="video-understanding-img-intro">
        <div class="video-understanding"></div>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionAuditing"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-3" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[3]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionAuditing"></application-scene>
      </div>
    </div>
    <div id="anchor-4" class="items-details client-case">
      <div class="solution-title">
        {{AnchorsItems[4]}}
      </div>
      <div class="client-case-auditing">
        <div class="case-info">
          <div class="auditing-title">小红书</div>
          <div class="auditing-content">
            国家工商总局启用了全国互联网广告监测中心，该中心采用“腾讯内容安全解决方案”，实现了人工智能技术在广告监管中的首次应用。接入腾讯优图的人工智能技术后，监测中心能够对互联网广告中存在的不适宜内容进行识别，尤其对具有广告导向的内容也能实现精准定位。
          </div>
        </div>
        <div class="case-img"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import advantageConstant from './data/AdvantageConstant';
import applicationConstant from './data/ApplicationConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';

const introAuditing = [
  {
    title: '不宜图像识别',
    content: '目标图片经过系统识别之后，会给出其不宜内容图片的概率，对高置信度有效打击，可帮助用户鉴别不宜内容图片，用AI捍卫互联网安全。',
    imgUrl: require('./img/intro/image_porn.jpg')
  }, {
    title: '恶意文本识别',
    content: '识别图片中的文字内容。业务方可以将识别出的文字通过消息过滤系统，及时过滤恶意广告和垃圾文本。',
    imgUrl: require('./img/intro/you_safe_pic1.3.jpg')
  }
];

export default {
  name: '',
  components: {
    SolutionBanner,
    SchemeAdvantage,
    ApplicationScene
  },
  data() {
    return {
      bannerConstant,
      advantageConstant,
      applicationConstant,
      introAuditing,
      AnchorsItems: ['方案介绍', '方案框架', '方案优势', '应用场景', '客户案例'],
      secondNavFixed: false,
      indexActive: 0
    };
  },
  methods: {
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    },
    handleGoDetailPage(url) {
      this.$router.transfer(url);
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.solution-security {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    &.client-case{
      background-color: rgb(245, 246, 247);
      padding-bottom: 100px;
    }
  }
  .video-understanding-img-intro {
    .video-understanding {
      width: 1170px;
      height: 690px;
      margin: 0 auto;
      background: url(./img/safe/app_bak.jpg) no-repeat;
    }
  }
  .solution-title{
    padding-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro{
    width: 1170px;
    margin: 0 auto;
    .content{
      font-size: 16px;
      color: #212121;
      line-height: 1.8;
      text-align: justify;
      margin-bottom: 26px;
    }
  }
  .core-competence{
    width: 1170px;
    margin: 0 auto;
    overflow: hidden;
    font-size: 0;
    .core-competence-item{
      vertical-align: top;
      width: 570px;
      height: 510px;
      margin-bottom: 30px;
      padding: 336px 20px 0 20px;
      display: inline-block;
      background-repeat: no-repeat;
      border: #e6e6e6 1px solid;
      color: #242526;
      &.core-even{
        margin-right: 30px;
      }
      &.last-core{
        margin-bottom: 0;
      }
      .core-title{
        font-size: 24px;
        line-height: 1.0;
        text-align: center;
      }
      .core-content{
        line-height: 1.8;
        font-size: 16px;
        text-align: justify;
        margin-top: 36px;
      }
    }
  }
  .auditing-img-intro{
    width: 1170px;
    height: 820px;
    margin: 58px auto 0;
    font-size: 0;
    text-align: center;
    .auditing-plat-item{
      position: relative;
      vertical-align: top;
      width: 380px;
      height: 410px;
      border: #e6e6e6 1px solid;
      margin: 0 0 10px 10px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center 0;
      color: #242526;
      &.no-margin-right{
        margin-right: 0;
      }
      .intro-title {
        font-size: 22px;
        line-height: 1.0;
        margin-top: 206px;
        text-align: center;
      }
      .intro-info {
        font-size: 16px;
        line-height: 1.8;
        text-align: justify;
        color: #212121;
        padding: 20px ;
      }
    }
  }
  .client-case-auditing{
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0;
    .case-info, .case-img{
      display: inline-block;
      height: 340px;
      width: 585px;
      vertical-align: top;
    }
    .case-img{
      background-image: url('./img/case/you_safe_pic5.jpg');
    }
    .case-info {
      padding: 58px 36px;
      background: #ffffff;
      line-height: 40px;
      border: #f0f0f0 1px solid;
      border-right: none;
      .auditing-title{
        line-height: 40px;
        font-size: 26px;
        padding-left: 138px;
        background-image: url(./img/case/case_logo_redbook.png);
        background-repeat: no-repeat;
        background-position: 0 center;
      }
      .auditing-content {
        margin-top: 28px;
        font-size: 16px;
        width: 510px;
        text-align: justify;
        line-height: 1.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionAuditing.vue